import { render, staticRenderFns } from "./reservationForm.vue?vue&type=template&id=06f513fc&scoped=true"
import script from "./reservationForm.vue?vue&type=script&lang=js"
export * from "./reservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f513fc",
  null
  
)

export default component.exports